export default __webpack_public_path__ + "static/media/check-in-circle.4208156a.svg";